import { render, staticRenderFns } from "./Overview2.vue?vue&type=template&id=2083b608&scoped=true&"
import script from "./Overview2.vue?vue&type=script&lang=js&"
export * from "./Overview2.vue?vue&type=script&lang=js&"
import style0 from "./Overview2.vue?vue&type=style&index=0&id=2083b608&prod&scoped=true&lang=css&"
import style1 from "./Overview2.vue?vue&type=style&index=1&id=2083b608&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083b608",
  null
  
)

export default component.exports